module.exports = __webpack_public_path__ + "static/media/sadcrying2.108abf21.jpg";